import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { FeatureToggleType, isXinStarCurrency, normalRtp, useFeatureToggleStore, usePlayerStore, xinStarRtp } from '@slot-nx/core'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

export const Paragraph10 = (props: ParagraphProps) => {
  const featureToggleStore = useFeatureToggleStore().toggleList
  const currency = usePlayerStore(x => x.currency)
  const isFromXinStar = useMemo(() => isXinStarCurrency(currency), [currency])
  const replaceRtp = useMemo(() => {
    return (text: string) => isFromXinStar
      ? text.replace(normalRtp, xinStarRtp)
      : text
  }, [isFromXinStar])

  const rtpRule1 = replaceRtp(t('gameRules_title8_content_1'))
  const rtpRule2 = replaceRtp(t('gameRules_title8_content_2'))

  const content = useMemo(() => {
    const disableRtpDisplay = featureToggleStore.get(FeatureToggleType.disableRTPDisplay)
    const noteY = disableRtpDisplay ? 0 : 250
    return (
      <Container y={props.y}>
        {!disableRtpDisplay
          ? (
              <Container>
                <Text
                  text={t('gameRules_title8')}
                  anchor={[0.5, 0]}
                  x={props.width / 2}
                  style={tableTitleStyle}
                />
                <Text
                  x={60}
                  y={100}
                  text={rtpRule1}
                  style={paragraphStyle}
                />
                <Text
                  x={60}
                  text={rtpRule2}
                  style={paragraphStyle}
                  y={150}
                />
              </Container>
            )
          : null}
        <Text
          x={60}
          text={t('gameRules_title8_content_3')}
          style={paragraphStyle}
          y={noteY}
        />
        <Text
          name="game_version"
          text="V1.3.5"
          anchor={[0.5, 0]}
          x={props.width / 2}
          y={noteY + 80}
          style={new TextStyle({
            fontSize: 40,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 960,
            breakWords: true,
            lineHeight: 45,
          })}
        />
        <Text name="space" text="" y={noteY + 140} />
      </Container>
    )
  }
  , [featureToggleStore, props.width, props.y, rtpRule1, rtpRule2])
  return content
}
